import "../assets/StickyImage.css";
import { defineComponent as O, useCssVars as Z, unref as n, ref as c, computed as i, watchEffect as E, openBlock as g, createBlock as k, Transition as _, withCtx as h, withDirectives as p, createElementVNode as u, createVNode as s, vShow as d, createCommentVNode as $, defineAsyncComponent as ne, onMounted as fe, createElementBlock as ge, Fragment as xe, withModifiers as ke, normalizeClass as Q, normalizeStyle as re, TransitionGroup as ue, provide as we } from "vue";
import { D as H, g as X, e as W, a as ce, d as F } from "./maps.ChaVcqWI.js";
import { u as oe } from "./index.72N0HVaZ.js";
import { d as pe } from "./debounce.BDLEW31m.js";
import { e as ee, o as A, a as ye, _ as Ie, h as K } from "./useStore.DvPy8fc7.js";
import { a as q, m as j, t as ze } from "./useModal.CgbJKM9V.js";
import { _ as P } from "./XClose.vue_vue_type_style_index_0_lang.BbzrX7pV.js";
import { _ as U } from "./Overlay.vue_vue_type_style_index_0_lang.CyNtTWNK.js";
import { _ as G } from "./Back.vue_vue_type_style_index_0_lang.BFHYB_JC.js";
import { _ as N } from "./Steps.vue_vue_type_style_index_0_lang.BZiYBok5.js";
import { _ as V } from "./Modal.vue_vue_type_style_index_0_lang.D99GhTsY.js";
import { _ as je, u as de, a as me, i as he } from "./useImageStyles.byYJo1RL.js";
import { _ as _e } from "./_plugin-vue_export-helper.CHgC5LLL.js";
import { d as be } from "./Text.vue_vue_type_style_index_0_lang.BEQZVGlu.js";
import { _ as Ce } from "./Icon.vue_vue_type_style_index_0_lang.Ckq5w3tI.js";
import { p as ve } from "./widgets-core.es.DdX21Kyh.js";
const Se = { class: "thn--tool-circular__content" }, De = { class: "thn--tool-circular__popup" }, $e = 530, go = /* @__PURE__ */ O({
  __name: "Circular",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(y, { expose: I }) {
    Z((b) => ({
      "2b7a1f1a": n(ee)(v.value)
    })), pe(ze, 200, { leading: !0, trailing: !1 });
    const t = y, e = A(), o = c(!1), r = c(!1), a = c(), { width: m, height: w } = oe(a), v = i(() => {
      const b = Math.min(m.value, w.value);
      return Math.min($e, b * 0.9);
    }), l = i(() => v.value), f = i(() => !!t.layout.closeOnClickOutside);
    E(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === H.Desktop ? {
          "--step-padding": "100px 75px 100px 60px",
          "--module-margin-top": "20px",
          "--xclose-margin": "0px"
        } : {
          "--step-padding": "70px 45px 40px 25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function x() {
      o.value = !1;
    }
    function S() {
      o.value = !0;
    }
    function z() {
      r.value = !0;
    }
    return I({
      show: x,
      hide: S
    }), (b, C) => (g(), k(_, {
      name: "fade",
      appear: "",
      onAfterEnter: z
    }, {
      default: h(() => [
        p(u("div", {
          class: "thn--tool-circular",
          ref_key: "rootDom",
          ref: a
        }, [
          s(U, {
            class: "thn--tool-circular__overlay",
            "close-on-click-outside": f.value
          }, null, 8, ["close-on-click-outside"]),
          u("div", Se, [
            s(_, { name: "fade-from-bottom" }, {
              default: h(() => [
                p(u("div", De, [
                  s(G, { class: "thn--tool-circular__back" }),
                  s(N, {
                    class: "thn--tool-circular__steps",
                    steps: t.steps,
                    "has-extra-steps": t.hasSteps,
                    "max-height": l.value
                  }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                  s(_, { name: "fade" }, {
                    default: h(() => [
                      p(s(V, { "terms-text": n(q) }, null, 8, ["terms-text"]), [
                        [d, n(j)]
                      ])
                    ]),
                    _: 1
                  })
                ], 512), [
                  [d, !o.value && r.value]
                ])
              ]),
              _: 1
            }),
            s(_, { name: "fade" }, {
              default: h(() => [
                p(s(P, null, null, 512), [
                  [d, !o.value && !n(j) && r.value]
                ])
              ]),
              _: 1
            })
          ])
        ], 512), [
          [d, !o.value]
        ])
      ]),
      _: 1
    }));
  }
}), He = {
  class: "thn--tool__popup thn--tool-custom-content",
  "data-add-module": !0
}, Ee = /* @__PURE__ */ O({
  __name: "CustomImage",
  props: {
    language: {},
    device: {},
    steps: {},
    layout: {}
  },
  setup(y, { expose: I }) {
    Z((D) => ({
      "5c36793f": z.value,
      "7284c47a": b.value
    }));
    const t = y, e = A(), o = c(), r = c(!1), { width: a, height: m } = oe(o), w = i(() => !!t.layout.closeOnClickOutside), v = i(() => t.steps[X.Main][0]), l = i(() => {
      if (a.value) {
        const D = (e == null ? void 0 : e.literals.device) === H.Mobile ? 0.9 : 0.8;
        return a.value * D;
      }
      return 300;
    }), f = i(() => {
      if (m.value) {
        const D = (e == null ? void 0 : e.literals.device) === H.Mobile ? 0.9 : 0.8;
        return m.value * D;
      }
      return 300;
    });
    function x() {
      r.value = !1;
    }
    function S() {
      r.value = !0;
    }
    E(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === H.Desktop ? {
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    const z = c("auto"), b = c("auto"), C = (D) => {
      z.value = D > window.innerHeight * 0.9 ? "100%" : "auto", b.value = D > window.innerHeight * 0.9 ? "90dvh" : "auto";
    };
    return I({
      show: x,
      hide: S
    }), (D, T) => (g(), k(_, {
      name: "fade",
      appear: ""
    }, {
      default: h(() => [
        p(u("div", {
          class: "thn--tool-custom-image",
          ref_key: "rootDom",
          ref: o
        }, [
          s(U, {
            class: "thn--tool-custom-image__overlay",
            "close-on-click-outside": w.value
          }, null, 8, ["close-on-click-outside"]),
          u("div", He, [
            s(je, {
              class: "thn--tool-custom-image__image",
              "module-props": v.value,
              "max-width": l.value,
              "max-height": f.value,
              onNaturalImageHeight: C
            }, null, 8, ["module-props", "max-width", "max-height"]),
            s(P)
          ])
        ], 512), [
          [d, !r.value]
        ])
      ]),
      _: 1
    }));
  }
}), xo = /* @__PURE__ */ _e(Ee, [["__scopeId", "data-v-8ef50d31"]]), Te = { class: "thn--tool-fullscreen__popup" }, ko = /* @__PURE__ */ O({
  __name: "Fullscreen",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(y, { expose: I }) {
    const t = y, e = A(), o = c(!1), r = c(!1), a = c(), m = i(() => {
      if (a.value)
        return a.value.offsetHeight;
    }), w = i(() => t.layout.closeOnClickOutside);
    E(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === H.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function v() {
      o.value = !1;
    }
    function l() {
      o.value = !0;
    }
    function f() {
      r.value = !0;
    }
    return I({
      show: v,
      hide: l
    }), (x, S) => (g(), k(_, {
      name: "fade",
      appear: "",
      onAfterEnter: f
    }, {
      default: h(() => [
        p(u("div", {
          class: "thn--tool-fullscreen",
          ref_key: "rootDom",
          ref: a
        }, [
          s(U, {
            class: "thn--tool-fullscreen__overlay",
            "close-on-click-outside": !!w.value
          }, null, 8, ["close-on-click-outside"]),
          s(_, { name: "fade-from-bottom" }, {
            default: h(() => [
              p(u("div", Te, [
                s(N, {
                  class: "thn--tool-fullscreen__steps",
                  steps: t.steps,
                  "has-extra-steps": t.hasSteps,
                  "max-height": m.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                s(_, { name: "fade" }, {
                  default: h(() => [
                    p(s(V, { "terms-text": n(q) }, null, 8, ["terms-text"]), [
                      [d, n(j)]
                    ])
                  ]),
                  _: 1
                })
              ], 512), [
                [d, !o.value && r.value]
              ])
            ]),
            _: 1
          }),
          n(j) ? $("", !0) : (g(), k(P, { key: 0 }))
        ], 512), [
          [d, !o.value]
        ])
      ]),
      _: 1
    }));
  }
}), Me = ["data-device"], wo = /* @__PURE__ */ O({
  __name: "FullscreenMini",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(y, { expose: I }) {
    const t = y, e = A(), o = c(!1), r = c(!1), a = c(), m = i(() => {
      if (a.value)
        return a.value.offsetHeight;
    }), w = i(() => t.layout.closeOnClickOutside);
    E(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === H.Desktop ? {
          "--step-padding": "20px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function v() {
      o.value = !1;
    }
    function l() {
      o.value = !0;
    }
    function f() {
      r.value = !0;
    }
    return I({
      show: v,
      hide: l
    }), (x, S) => (g(), k(_, {
      name: "fade",
      appear: "",
      onAfterEnter: f
    }, {
      default: h(() => [
        p(u("div", {
          class: "thn--tool-fullscreen-mini",
          ref_key: "rootDom",
          ref: a
        }, [
          s(U, {
            class: "thn--tool-fullscreen-mini__overlay",
            "close-on-click-outside": !!w.value
          }, null, 8, ["close-on-click-outside"]),
          s(_, { name: "fade-from-bottom" }, {
            default: h(() => {
              var z;
              return [
                p(u("div", {
                  class: "thn--tool-fullscreen-mini__popup",
                  "data-device": (z = n(e)) == null ? void 0 : z.literals.device
                }, [
                  s(N, {
                    class: "thn--tool-fullscreen-mini__steps",
                    steps: t.steps,
                    "has-extra-steps": t.hasSteps,
                    "max-height": m.value
                  }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                  s(_, { name: "fade" }, {
                    default: h(() => [
                      p(s(V, { "terms-text": n(q) }, null, 8, ["terms-text"]), [
                        [d, n(j)]
                      ])
                    ]),
                    _: 1
                  })
                ], 8, Me), [
                  [d, !o.value && r.value]
                ])
              ];
            }),
            _: 1
          }),
          n(j) ? $("", !0) : (g(), k(P, { key: 0 }))
        ], 512), [
          [d, !o.value]
        ])
      ]),
      _: 1
    }));
  }
}), Oe = ["data-device"], yo = /* @__PURE__ */ O({
  __name: "LowerNotification",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(y, { expose: I }) {
    const t = y, e = A(), o = c(!1), r = c(), a = i(() => (e == null ? void 0 : e.handlers.stepActive) || X.Main), m = i(() => (e == null ? void 0 : e.literals.device) === H.Mobile), w = i(() => t.steps[X.Main].filter(
      (C) => C.moduleType !== W.Icon
    ).length), v = i(() => t.steps[X.Main].find(
      (C) => C.moduleType === W.Icon
    )), l = i(() => t.steps[a.value].find(
      (C) => C.moduleType === W.Button
    )), f = i(() => !!t.steps[X.Main].find(
      (C) => C.moduleType === W.Form
    )), x = i(() => Object.keys(t.steps).reduce((D, T) => (D[T] = t.steps[T].filter(
      (R) => R.moduleType !== W.Icon && R.moduleType !== W.Button || R.moduleType !== W.Icon && w.value > 4 || R.moduleType !== W.Icon && f.value || m.value
    ), D), {})), S = i(() => {
      if (r.value)
        return m.value ? 0 : 270;
    });
    E(() => {
      e == null || e.styles.addCssVariables(
        m.value ? {
          "--step-padding": "5px",
          "--module-margin-top": "10px",
          "--xclose-margin": "5px"
        } : {
          "--module-margin-top": "10px",
          "--step-padding": `5px 15px 10px ${v.value ? 20 : 0}px`,
          "--xclose-margin": "7px"
        }
      );
    });
    function z() {
      o.value = !1;
    }
    function b() {
      o.value = !0;
    }
    return I({
      show: z,
      hide: b
    }), (C, D) => (g(), k(_, {
      name: "fade-from-bottom",
      appear: ""
    }, {
      default: h(() => {
        var T;
        return [
          p(u("div", {
            class: "thn--tool-lower-notification",
            ref_key: "rootDom",
            ref: r
          }, [
            u("div", {
              class: "thn--tool-lower-notification__popup",
              "data-device": (T = n(e)) == null ? void 0 : T.literals.device
            }, [
              s(G, { class: "thn--tool-lower-notification__back" }),
              v.value && !m.value ? (g(), k(Ce, {
                key: 0,
                class: "thn--tool-lower-notification__icon",
                "module-props": v.value
              }, null, 8, ["module-props"])) : $("", !0),
              s(N, {
                class: "thn--tool-lower-notification__steps",
                steps: x.value,
                "has-extra-steps": t.hasSteps,
                "max-height": S.value,
                "layout-kind": n(ce).LowerNotification
              }, null, 8, ["steps", "has-extra-steps", "max-height", "layout-kind"]),
              l.value && !m.value && w.value <= 4 && !f.value ? (g(), k(be, {
                key: 1,
                class: "thn--tool-lower-notification__button",
                "module-props": l.value,
                "has-extra-steps": t.hasSteps,
                "data-module-id": l.value.id,
                "data-module-special": !0
              }, null, 8, ["module-props", "has-extra-steps", "data-module-id"])) : $("", !0),
              n(j) ? $("", !0) : (g(), k(P, {
                key: 2,
                class: "thn--tool-lower-notification__xclose"
              })),
              s(_, { name: "fade" }, {
                default: h(() => [
                  p(s(V, { "terms-text": n(q) }, null, 8, ["terms-text"]), [
                    [d, n(j)]
                  ])
                ]),
                _: 1
              })
            ], 8, Oe)
          ], 512), [
            [d, !o.value]
          ])
        ];
      }),
      _: 1
    }));
  }
}), Ae = ["data-position"], Pe = ["data-closed"], Be = ["data-show-number", "disabled", "aria-expanded", "aria-label"], ae = 40, ie = 0.6, le = 620, Le = /* @__PURE__ */ O({
  __name: "NotificationTab",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  emits: [
    "after-leave"
  ],
  setup(y, { expose: I, emit: t }) {
    Z((L) => ({
      "044e2751": n(ee)(ae),
      b0eafcd6: n(ee)(C.value)
    }));
    const { t: e } = ve(), o = y, r = t, a = c(!0), m = c(), { width: w, height: v } = oe(m), l = A(), f = c(!1), x = i(() => {
      var L;
      return ((L = o.layout.position) == null ? void 0 : L.charAt(0)) === "L";
    }), S = i(() => {
      var L;
      if ((L = o.layout.icon) != null && L.value) {
        const Y = `${ye(o.layout.icon.value)}Icon`;
        return ne(() => Ie(/* @__PURE__ */ Object.assign({ "../../node_modules/@thehotelsnetwork/icons/vue/personalization/AndroidAppleIcon.js": () => import("./AndroidAppleIcon.Ce3m-x9g.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/AndroidIcon.js": () => import("./AndroidIcon.D59wfG9g.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/AppleIcon.js": () => import("./AppleIcon.BqnkkuKL.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/AutumnIcon.js": () => import("./AutumnIcon.CSxJz0UO.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BabyBottleIcon.js": () => import("./BabyBottleIcon.Ba9ICO6D.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BaliBedIcon.js": () => import("./BaliBedIcon.CtKvYP2x.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BathtubIcon.js": () => import("./BathtubIcon.BsN_f94d.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BeachballIcon.js": () => import("./BeachballIcon.CGxH3w1e.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BeerIcon.js": () => import("./BeerIcon.JgpY0O9A.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BellIcon.js": () => import("./BellIcon.D6Uir9XB.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BicycleIcon.js": () => import("./BicycleIcon.C09WLIqu.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BikeIcon.js": () => import("./BikeIcon.D9eOeJg8.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BinocularsIcon.js": () => import("./BinocularsIcon.Bk2G58hY.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BoatIcon.js": () => import("./BoatIcon.DWyXsPwt.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/Book2Icon.js": () => import("./Book2Icon.C-4bP1KQ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BookIcon.js": () => import("./BookIcon.DkmG6OCP.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BreadIcon.js": () => import("./BreadIcon.ClpRBAXL.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BriefcaseIcon.js": () => import("./BriefcaseIcon.BJbaUrDS.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BusIcon.js": () => import("./BusIcon.BU_u6QxI.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BusNewIcon.js": () => import("./BusNewIcon.Cilr6kAF.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BycicleIcon.js": () => import("./BycicleIcon.BZBVJWTk.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CactusIcon.js": () => import("./CactusIcon.BStXXFwi.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CakeIcon.js": () => import("./CakeIcon.DvQFC2Cu.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CalendarIcon.js": () => import("./CalendarIcon.BCTm2dSH.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CameraIcon.js": () => import("./CameraIcon.D0M6m-Ea.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CarIcon.js": () => import("./CarIcon.BN_V6OW_.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CarNewIcon.js": () => import("./CarNewIcon.CYgdMbhR.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CarrotIcon.js": () => import("./CarrotIcon.B-LbpgkZ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CheckIcon.js": () => import("./CheckIcon.CcHVV6hy.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ChurchIcon.js": () => import("./ChurchIcon.D9b_dCWf.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ClockIcon.js": () => import("./ClockIcon.BWEPz_Hy.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CocktailIcon.js": () => import("./CocktailIcon.XOV-0WDH.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CoffeeIcon.js": () => import("./CoffeeIcon.D5evvPd9.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CupsIcon.js": () => import("./CupsIcon.qUhdioKA.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/DangerIcon.js": () => import("./DangerIcon.DT2DUSUq.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/DiscountIcon.js": () => import("./DiscountIcon.XPTy3zJl.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/DownloadMobileIcon.js": () => import("./DownloadMobileIcon.CTVj4YnV.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/EggIcon.js": () => import("./EggIcon.gJR9gPWC.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/EnvelopeIcon.js": () => import("./EnvelopeIcon.DaxFQToj.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/FacebookIcon.js": () => import("./FacebookIcon.T-tX6GjS.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/FamilyIcon.js": () => import("./FamilyIcon.aFJH10rD.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/FlipFlopsIcon.js": () => import("./FlipFlopsIcon.eBjVztuk.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GhostIcon.js": () => import("./GhostIcon.C8_Nbvg5.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GiftIcon.js": () => import("./GiftIcon.DpdbfXCQ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GolfIcon.js": () => import("./GolfIcon.DlLqrVf5.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GraphIcon.js": () => import("./GraphIcon.DFo4J-S-.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GraphUpIcon.js": () => import("./GraphUpIcon.DcPLofhe.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GymIcon.js": () => import("./GymIcon.-rHYS7-S.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HalloweenIcon.js": () => import("./HalloweenIcon.BKPA3FNw.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HamburgerIcon.js": () => import("./HamburgerIcon.Cc3QkvuN.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HandShakeIcon.js": () => import("./HandShakeIcon.Bz6Ol0vW.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HashtagIcon.js": () => import("./HashtagIcon.Bcj0HGjz.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HeartIcon.js": () => import("./HeartIcon.BW1FSriv.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HeartsIcon.js": () => import("./HeartsIcon.D3fMAQux.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HeartsNewIcon.js": () => import("./HeartsNewIcon.Zioj2TFF.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HotelIcon.js": () => import("./HotelIcon.B5Qba7M6.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/InformationIcon.js": () => import("./InformationIcon.DOXGspCQ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/InstagramIcon.js": () => import("./InstagramIcon.BYzpKAQv.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LastReservationIcon.js": () => import("./LastReservationIcon.Bp8te3ka.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LastWeekStayedIcon.js": () => import("./LastWeekStayedIcon.DJ7NhwBI.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LaundryIcon.js": () => import("./LaundryIcon.COSYLGm1.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LightIcon.js": () => import("./LightIcon.D2dFJ8Qs.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LockGreatPriceIcon.js": () => import("./LockGreatPriceIcon.0ZJ_H9Jy.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/MaskIcon.js": () => import("./MaskIcon.D6OtYUfw.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/MusicIcon.js": () => import("./MusicIcon.Dc6x9kQB.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PalmIcon.js": () => import("./PalmIcon.Bv-PS4bP.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ParkingCarIcon.js": () => import("./ParkingCarIcon.DiLVMG51.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ParkingPIcon.js": () => import("./ParkingPIcon.BBA1vmyV.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PawIcon.js": () => import("./PawIcon.DIYsPJ4E.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PictureIcon.js": () => import("./PictureIcon.ByEUCyAF.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PinIcon.js": () => import("./PinIcon._FIrbnqm.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PizzaIcon.js": () => import("./PizzaIcon.DfPPGTtP.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PlaneIcon.js": () => import("./PlaneIcon.CA12HAqM.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PlatterIcon.js": () => import("./PlatterIcon.CRNnpxMQ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PoolIcon.js": () => import("./PoolIcon.Dd1_K1lp.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PrizeIcon.js": () => import("./PrizeIcon.CEmq9FRR.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RabbitIcon.js": () => import("./RabbitIcon.CeQLI7M2.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RaceIcon.js": () => import("./RaceIcon.DMEMTBQu.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RelaxIcon.js": () => import("./RelaxIcon.Di7AsJ5h.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RestaurantIcon.js": () => import("./RestaurantIcon.Df5nw0MC.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ReviewsIcon.js": () => import("./ReviewsIcon.CVUG9v_F.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RoomIcon.js": () => import("./RoomIcon.BBygCFIz.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RoseIcon.js": () => import("./RoseIcon.DyPxzQvx.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SantaIcon.js": () => import("./SantaIcon.BWe78Ox_.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceDollarIcon.js": () => import("./SecurePriceDollarIcon.Ch4mkbEo.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceEuroIcon.js": () => import("./SecurePriceEuroIcon.YtJ-VehJ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceIcon.js": () => import("./SecurePriceIcon.Ch4mkbEo.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePricePoundIcon.js": () => import("./SecurePricePoundIcon.Bq7uH4TE.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceYenIcon.js": () => import("./SecurePriceYenIcon.Dk_E6xFN.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ShoppingIcon.js": () => import("./ShoppingIcon.8dtsN1cd.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SkiIcon.js": () => import("./SkiIcon.C2zs3hk3.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SnowIcon.js": () => import("./SnowIcon.Bn1T00xF.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SpacerIcon.js": () => import("./SpacerIcon.-A9pCNqE.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SpecialIcon.js": () => import("./SpecialIcon.B6TeHwGZ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/StarIcon.js": () => import("./StarIcon.BdVMO6nj.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SunIcon.js": () => import("./SunIcon.BBk_bORh.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SurfIcon.js": () => import("./SurfIcon.ajX4djVO.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ThunderIcon.js": () => import("./ThunderIcon.6k9RC-uG.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TieIcon.js": () => import("./TieIcon.8ACySmda.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TreeIcon.js": () => import("./TreeIcon.BhM-3ef4.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TripadvisorIcon.js": () => import("./TripadvisorIcon.D7p7JPED.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TrophyIcon.js": () => import("./TrophyIcon.BQMBJ0cE.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TvIcon.js": () => import("./TvIcon.DP_1G6Et.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/UserIcon.js": () => import("./UserIcon.D7iosg3a.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/UsersIcon.js": () => import("./UsersIcon.BORnyKHZ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/UsersNewIcon.js": () => import("./UsersNewIcon.Crg4GRbQ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/VirusIcon.js": () => import("./VirusIcon.DgltyNxg.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/VoucherIcon.js": () => import("./VoucherIcon.8Hc1prKP.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WeddingIcon.js": () => import("./WeddingIcon.C7ZLkflB.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WhatsappIcon.js": () => import("./WhatsappIcon.DpQSm_yX.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WheelchairIcon.js": () => import("./WheelchairIcon.DtoQNway.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WifiIcon.js": () => import("./WifiIcon.BCdEhEpK.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WineIcon.js": () => import("./WineIcon.3-I6YBP1.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/index.js": () => import("./index.BaCRT2hI.js") }), `../../node_modules/@thehotelsnetwork/icons/vue/personalization/${Y}.js`, 8));
      }
      return null;
    }), z = i(() => ne(() => x.value ? import("./ChevronDownIcon.BjrxvU4d.js") : import("./ChevronUpIcon.Dnr2MR6B.js")));
    E(() => {
      l == null || l.styles.addCssVariables(
        l.literals.device === H.Desktop ? {
          "--step-padding": "32px 45px 32px 32px",
          "--module-margin-top": "16px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px 40px 25px 25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    const b = i(() => o.layout.position === "UML" || o.layout.position === "UMR" || o.layout.position === "LML" || o.layout.position === "LMR"), C = i(() => w.value ? w.value - 2 * ae : 0), D = i(() => v.value && b.value ? v.value * ie : v.value ? v.value > le ? le : v.value * ie : 0), T = i(() => {
      let L = "up";
      return (x.value && a.value || !x.value && !a.value) && (L = "down"), `fade-tab-icon-${L}`;
    });
    function R() {
      a.value = !1;
    }
    function M() {
      a.value = !0, r("after-leave");
    }
    const B = pe(() => {
      a.value = !a.value;
    }, 200, { leading: !0, trailing: !1 });
    function te() {
      f.value = !0;
    }
    return E(() => {
      l != null && l.extraData.builderMode && setTimeout(() => {
        a.value = !1;
      }, 500);
    }), fe(() => {
      o.layout.showOpen && setTimeout(() => {
        a.value = !1;
      }, 1e3);
    }), I({
      show: R,
      hide: M
    }), (L, Y) => {
      var se;
      return g(), ge(xe, null, [
        u("div", {
          class: "thn--tool-notification-tab__sizer",
          ref_key: "sizerDom",
          ref: m
        }, null, 512),
        u("div", {
          class: "thn--tool-notification-tab",
          "data-position": L.layout.position
        }, [
          u("div", {
            class: "thn--tool-notification-tab__popup",
            "data-closed": a.value
          }, [
            s(G, { class: "thn--tool-notification-tab__back" }),
            s(N, {
              class: "thn--tool-notification-tab__steps",
              steps: o.steps,
              "has-extra-steps": o.hasSteps,
              "max-height": D.value
            }, null, 8, ["steps", "has-extra-steps", "max-height"]),
            s(P, {
              "trigger-dismiss": !1,
              onMousedown: ke(n(B), ["left"]),
              onClick: n(B)
            }, null, 8, ["onMousedown", "onClick"]),
            s(_, {
              name: "fade",
              appear: "",
              onAfterEnter: te
            }, {
              default: h(() => [
                p(s(V, { "terms-text": n(q) }, null, 8, ["terms-text"]), [
                  [d, n(j)]
                ])
              ]),
              _: 1
            })
          ], 8, Pe),
          u("button", {
            type: "button",
            class: "thn--tool-notification-tab__tab",
            onClick: Y[0] || (Y[0] = //@ts-ignore
            (...J) => n(B) && n(B)(...J)),
            "data-show-number": a.value,
            disabled: (se = n(l)) == null ? void 0 : se.extraData.builderMode,
            "aria-expanded": !a.value,
            "aria-label": n(e)("Expand notification")
          }, [
            s(_, { name: T.value }, {
              default: h(() => {
                var J;
                return [
                  a.value || (J = n(l)) != null && J.extraData.builderMode ? (g(), k(n(S), {
                    key: 0,
                    class: "thn--tool-notification-tab__icon",
                    "aria-hidden": "true"
                  })) : a.value ? $("", !0) : (g(), k(n(z), {
                    key: 1,
                    class: "thn--tool-notification-tab__icon",
                    "aria-hidden": "true"
                  }))
                ];
              }),
              _: 1
            }, 8, ["name"])
          ], 8, Be)
        ], 8, Ae)
      ], 64);
    };
  }
}), Io = /* @__PURE__ */ _e(Le, [["__scopeId", "data-v-ebaee5e2"]]), qe = ["data-layout-position", "data-size", "data-device"], zo = /* @__PURE__ */ O({
  __name: "Sidebar",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(y, { expose: I }) {
    const t = y, e = A(), o = c(!1), r = c(!1), a = c(), m = c(), w = i(() => {
      if (a.value) {
        const z = t.layout.position === F.Bottom ? 0.5 : 1;
        return a.value.offsetHeight * z;
      }
    }), v = i(() => t.layout.closeOnClickOutside), l = i(() => {
      switch (t.layout.position) {
        case F.Left:
          return "fade-from-left";
        case F.Right:
          return "fade-from-right";
        case F.Bottom:
        default:
          return "fade-from-bottom";
      }
    });
    E(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === H.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function f() {
      o.value = !1;
    }
    function x() {
      o.value = !0;
    }
    function S() {
      r.value = !0;
    }
    return I({
      show: f,
      hide: x
    }), (z, b) => (g(), k(_, {
      name: "fade",
      appear: "",
      onAfterEnter: S
    }, {
      default: h(() => [
        p(u("div", {
          class: "thn--tool-sidebar",
          ref_key: "rootDom",
          ref: a
        }, [
          s(U, {
            class: "thn--tool-sidebar__overlay",
            "close-on-click-outside": !!v.value
          }, null, 8, ["close-on-click-outside"]),
          s(_, { name: l.value }, {
            default: h(() => [
              p(u("div", {
                class: "thn--tool-sidebar__popup",
                ref_key: "popupDom",
                ref: m,
                "data-layout-position": t.layout.position,
                "data-size": t.layout.size,
                "data-device": t.device
              }, [
                s(G, { class: "thn--tool-sidebar__back" }),
                s(N, {
                  class: "thn--tool-sidebar__steps",
                  steps: t.steps,
                  "has-extra-steps": t.hasSteps,
                  "max-height": w.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                n(j) ? $("", !0) : (g(), k(P, { key: 0 })),
                s(_, { name: "fade" }, {
                  default: h(() => [
                    p(s(V, { "terms-text": n(q) }, null, 8, ["terms-text"]), [
                      [d, n(j)]
                    ])
                  ]),
                  _: 1
                })
              ], 8, qe), [
                [d, !o.value && r.value]
              ])
            ]),
            _: 1
          }, 8, ["name"])
        ], 512), [
          [d, !o.value]
        ])
      ]),
      _: 1
    }));
  }
}), Ne = ["data-size", "data-position"], Ve = { class: "thn--tool-side-gradient__content" }, jo = /* @__PURE__ */ O({
  __name: "SideGradient",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(y, { expose: I }) {
    Z((l) => ({
      a8d7e3ec: m.value
    }));
    const t = y, e = A(), o = c(!1), r = c(), a = i(() => {
      if (r.value) {
        const l = t.layout.position === F.Bottom ? 0.5 : 1;
        return r.value.offsetHeight * l;
      }
    }), m = i(() => {
      const {
        base: l = "#ffffff",
        gradient: f
      } = (e == null ? void 0 : e.styles.colors.background) || {};
      let x;
      switch (t.layout.position) {
        case F.Bottom:
          x = 360;
          break;
        case F.Right:
          x = -90;
          break;
        default:
          x = 90;
          break;
      }
      const S = e != null && e.rtl && t.layout.position !== F.Bottom ? `${K(f || l, 0)} 0%, 
       ${K(f || l, 0.75)} 41.36%, 
       ${K(l, 0.95)} 71.2%, 
       ${l} 99.93%` : `${l} 0.07%, 
       ${K(l, 0.95)} 28.8%, 
       ${K(f || l, 0.75)} 58.64%, 
       ${K(f || l, 0)} 100%`;
      return `linear-gradient(${x}deg, ${S})`;
    });
    E(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === H.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function w() {
      o.value = !1;
    }
    function v() {
      o.value = !0;
    }
    return I({
      show: w,
      hide: v
    }), (l, f) => (g(), k(_, {
      name: "fade",
      appear: ""
    }, {
      default: h(() => [
        p(u("div", {
          class: "thn--tool-side-gradient",
          ref_key: "rootDom",
          ref: r
        }, [
          u("div", {
            class: "thn--tool-side-gradient__popup",
            "data-size": t.layout.size,
            "data-position": t.layout.position
          }, [
            u("div", Ve, [
              s(N, {
                class: "thn--tool-side-gradient__steps",
                steps: t.steps,
                "has-extra-steps": t.hasSteps,
                "max-height": a.value,
                layout: t.layout
              }, null, 8, ["steps", "has-extra-steps", "max-height", "layout"]),
              n(j) ? $("", !0) : (g(), k(P, {
                key: 0,
                class: "thn--tool-side-gradient__xclose"
              })),
              s(_, { name: "fade" }, {
                default: h(() => [
                  p(s(V, { "terms-text": n(q) }, null, 8, ["terms-text"]), [
                    [d, n(j)]
                  ])
                ]),
                _: 1
              })
            ])
          ], 8, Ne)
        ], 512), [
          [d, !o.value]
        ])
      ]),
      _: 1
    }));
  }
}), Re = { class: "thn--tool-square__popup" }, bo = /* @__PURE__ */ O({
  __name: "Square",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(y, { expose: I }) {
    const t = y, e = A(), o = c(!1), r = c(!1), a = c(), m = i(() => {
      if (a.value)
        return a.value.offsetHeight * 0.8;
    }), w = i(() => !!t.layout.closeOnClickOutside);
    E(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === H.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function v() {
      o.value = !1;
    }
    function l() {
      o.value = !0;
    }
    function f() {
      r.value = !0;
    }
    return I({
      show: v,
      hide: l
    }), (x, S) => (g(), k(_, {
      name: "fade",
      appear: "",
      onAfterEnter: f
    }, {
      default: h(() => [
        p(u("div", {
          class: "thn--tool-square",
          ref_key: "rootDom",
          ref: a
        }, [
          s(U, {
            class: "thn--tool-square__overlay",
            "close-on-click-outside": w.value
          }, null, 8, ["close-on-click-outside"]),
          s(_, { name: "fade-from-bottom" }, {
            default: h(() => [
              p(u("div", Re, [
                s(G, { class: "thn--tool-square__back" }),
                s(N, {
                  class: "thn--tool-square__steps",
                  steps: t.steps,
                  "has-extra-steps": t.hasSteps,
                  "max-height": m.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                n(j) ? $("", !0) : (g(), k(P, { key: 0 })),
                s(_, { name: "fade" }, {
                  default: h(() => [
                    p(s(V, { "terms-text": n(q) }, null, 8, ["terms-text"]), [
                      [d, n(j)]
                    ])
                  ]),
                  _: 1
                })
              ], 512), [
                [d, !o.value && r.value]
              ])
            ]),
            _: 1
          })
        ], 512), [
          [d, !o.value]
        ])
      ]),
      _: 1
    }));
  }
}), Ge = ["data-loaded"], We = ["src", "alt"], Fe = { class: "w-full h-full bg-base-300 flex items-center justify-center" }, Co = /* @__PURE__ */ O({
  __name: "SquareImage",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(y, { expose: I }) {
    const { t } = ve(), e = A(), o = y, r = c(), a = c(!1), m = c(!1), w = c(!1), v = i(() => o.layout), l = i(() => o.device), { imageUrl: f, imageAlt: x } = de(v, l), S = i(() => {
      if (r.value) {
        const B = o.device === H.Mobile ? 0.4 : 0.8;
        return r.value.offsetHeight * B;
      }
    }), z = i(() => !!o.layout.closeOnClickOutside), b = i(() => {
      var B;
      return o.device === H.Mobile ? "top" : ((B = o.layout) == null ? void 0 : B.imagePosition) ?? "left";
    }), { imageStyles: C } = me(
      i(() => o.layout),
      i(() => o.device),
      b
    );
    E(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === H.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      ), f.value || (a.value = !1);
    });
    function D() {
      m.value = !1;
    }
    function T() {
      m.value = !0;
    }
    function R() {
      w.value = !0;
    }
    function M() {
      a.value = !0;
    }
    return I({
      show: D,
      hide: T
    }), (B, te) => (g(), k(_, {
      name: "fade",
      onAfterEnter: R,
      appear: ""
    }, {
      default: h(() => [
        p(u("div", {
          class: "thn--tool-square-image",
          ref_key: "rootDom",
          ref: r
        }, [
          s(U, {
            class: "thn--tool-square-image__overlay",
            "close-on-click-outside": z.value
          }, null, 8, ["close-on-click-outside"]),
          s(_, { name: "fade-from-bottom" }, {
            default: h(() => [
              p(u("div", {
                class: Q([
                  "thn--tool-square-image__popup",
                  b.value
                ])
              }, [
                n(C) ? (g(), k(G, {
                  key: 0,
                  class: "thn--tool-square-image__back"
                })) : $("", !0),
                u("div", {
                  class: Q([
                    "thn--tool-square-image__popup__wrapper",
                    b.value
                  ])
                }, [
                  u("div", {
                    class: "thn--tool-square-image__image",
                    style: re(n(C)),
                    "data-loaded": a.value
                  }, [
                    s(ue, { name: "fade" }, {
                      default: h(() => [
                        p(u("img", {
                          ref: "imageDOM",
                          src: n(f),
                          onLoad: M,
                          alt: n(x)
                        }, null, 40, We), [
                          [d, a.value]
                        ]),
                        p(u("div", Fe, [
                          s(n(he), {
                            class: "img-icon",
                            alt: n(t)("Picture icon")
                          }, null, 8, ["alt"])
                        ], 512), [
                          [d, !a.value]
                        ])
                      ]),
                      _: 1
                    })
                  ], 12, Ge),
                  u("div", {
                    class: Q(["thn--tool-square-image__content", [{ relative: a.value }]])
                  }, [
                    n(C) ? $("", !0) : (g(), k(G, {
                      key: 0,
                      class: "thn--tool-square-image__back"
                    })),
                    s(N, {
                      class: "thn--tool-square-image__steps",
                      steps: o.steps,
                      "has-extra-steps": o.hasSteps,
                      "max-height": S.value,
                      "layout-kind": n(ce).SquareImage,
                      "image-position": b.value
                    }, null, 8, ["steps", "has-extra-steps", "max-height", "layout-kind", "image-position"])
                  ], 2),
                  n(j) ? $("", !0) : (g(), k(P, { key: 0 })),
                  s(_, { name: "fade" }, {
                    default: h(() => [
                      p(s(V, { "terms-text": n(q) }, null, 8, ["terms-text"]), [
                        [d, n(j)]
                      ])
                    ]),
                    _: 1
                  })
                ], 2)
              ], 2), [
                [d, !m.value && w.value]
              ])
            ]),
            _: 1
          })
        ], 512), [
          [d, !m.value]
        ])
      ]),
      _: 1
    }));
  }
}), Ue = ["data-position", "data-size"], So = /* @__PURE__ */ O({
  __name: "Sticky",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(y, { expose: I }) {
    const t = y, e = A(), o = c(!1), r = c(!1), a = c(), m = i(() => {
      if (a.value)
        return a.value.offsetHeight * 0.6;
    });
    i(() => !!t.layout.closeOnClickOutside);
    const w = i(() => {
      const { position: x } = t.layout;
      return x ? `fade-from-${x.slice(-1) === "L" ? "left" : "right"}` : "fade";
    });
    E(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === H.Desktop ? {
          "--step-padding": "24px 40px 24px 24px",
          "--module-margin-top": "10px",
          "--xclose-margin": "5px"
        } : {
          "--step-padding": "24px 40px 24px 24px",
          "--module-margin-top": "8px",
          "--xclose-margin": "5px"
        }
      );
    });
    function v() {
      o.value = !1;
    }
    function l() {
      o.value = !0;
    }
    function f() {
      r.value = !0;
    }
    return I({
      show: v,
      hide: l
    }), (x, S) => (g(), k(_, {
      name: "fade",
      appear: "",
      onAfterEnter: f
    }, {
      default: h(() => [
        p(u("div", {
          class: "thn--tool-sticky",
          ref_key: "rootDom",
          ref: a
        }, [
          s(_, { name: w.value }, {
            default: h(() => [
              p(u("div", {
                class: "thn--tool-sticky__popup",
                "data-position": x.layout.position,
                "data-size": t.layout.size
              }, [
                s(G, { class: "thn--tool-sticky__back" }),
                s(N, {
                  class: "thn--tool-sticky__steps",
                  steps: t.steps,
                  "has-extra-steps": t.hasSteps,
                  "max-height": m.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                n(j) ? $("", !0) : (g(), k(P, { key: 0 })),
                s(_, { name: "fade" }, {
                  default: h(() => [
                    p(s(V, { "terms-text": n(q) }, null, 8, ["terms-text"]), [
                      [d, n(j)]
                    ])
                  ]),
                  _: 1
                })
              ], 8, Ue), [
                [d, !o.value && r.value]
              ])
            ]),
            _: 1
          }, 8, ["name"])
        ], 512), [
          [d, !o.value]
        ])
      ]),
      _: 1
    }));
  }
}), Ke = ["data-device", "data-position", "data-size", "data-image-position"], Xe = { class: "thn--tool-sticky-image__popup__wrapper" }, Ye = ["data-loaded"], Je = { class: "image__wrapper" }, Qe = ["src", "alt"], Ze = { class: "w-full h-full bg-base-300 flex items-center justify-center" }, Do = /* @__PURE__ */ O({
  __name: "StickyImage",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(y, { expose: I }) {
    const t = y;
    we("layout", c(t.layout));
    const e = A(), o = c(!1), r = c(!1), a = c(!1), m = c(), w = i(() => t.layout), v = i(() => t.device), { imageUrl: l, imageAlt: f } = de(w, v), x = i(() => {
      if (m.value)
        return m.value.offsetHeight * 0.6;
    }), S = i(() => {
      const { position: M } = t.layout;
      return M ? `fade-from-${M.slice(-1) === "L" ? "left" : "right"}` : "fade";
    }), z = i(() => {
      var M;
      return ((M = t.layout) == null ? void 0 : M.imagePosition) ?? "left";
    }), { imageStyles: b } = me(
      i(() => t.layout),
      i(() => t.device),
      z
    );
    E(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === H.Desktop ? {
          "--step-padding": `16px ${z.value === "left" ? "40px" : "16px"} 16px 16px`,
          "--module-margin-top": "10px",
          "--xclose-margin": "5px"
        } : {
          "--step-padding": `16px ${z.value === "left" ? "40px" : "16px"} 16px 16px`,
          "--module-margin-top": "8px",
          "--xclose-margin": "5px"
        }
      ), l.value || (r.value = !1);
    });
    function C() {
      o.value = !1;
    }
    function D() {
      o.value = !0;
    }
    function T() {
      a.value = !0;
    }
    function R() {
      r.value = !0;
    }
    return I({
      show: C,
      hide: D
    }), (M, B) => (g(), k(_, {
      name: "fade",
      appear: "",
      onAfterEnter: T
    }, {
      default: h(() => [
        p(u("div", {
          class: "thn--tool-sticky-image",
          ref_key: "rootDom",
          ref: m
        }, [
          s(_, { name: S.value }, {
            default: h(() => [
              p(u("div", {
                class: "thn--tool-sticky-image__popup",
                "data-device": M.device,
                "data-position": M.layout.position,
                "data-size": t.layout.size,
                "data-image-position": z.value
              }, [
                u("div", Xe, [
                  n(b) ? (g(), k(G, {
                    key: 0,
                    class: "thn--tool-square-image__back"
                  })) : $("", !0),
                  u("div", {
                    class: "thn--tool-sticky-image__image",
                    style: re(n(b)),
                    "data-loaded": r.value
                  }, [
                    s(ue, { name: "fade" }, {
                      default: h(() => [
                        p(u("div", Je, [
                          u("img", {
                            ref: "imageDOM",
                            src: n(l),
                            onLoad: R,
                            alt: n(f)
                          }, null, 40, Qe)
                        ], 512), [
                          [d, r.value]
                        ]),
                        p(u("div", Ze, [
                          s(n(he), { class: "img-icon" })
                        ], 512), [
                          [d, !r.value]
                        ])
                      ]),
                      _: 1
                    })
                  ], 12, Ye),
                  u("div", {
                    class: Q(["thn--tool-sticky-image__content", [{ relative: r.value }]])
                  }, [
                    n(b) ? $("", !0) : (g(), k(G, {
                      key: 0,
                      class: "thn--tool-square-image__back"
                    })),
                    s(N, {
                      class: "thn--tool-sticky-image__steps",
                      steps: t.steps,
                      "has-extra-steps": t.hasSteps,
                      "max-height": x.value
                    }, null, 8, ["steps", "has-extra-steps", "max-height"])
                  ], 2),
                  n(j) ? $("", !0) : (g(), k(P, { key: 1 }))
                ]),
                s(_, { name: "fade" }, {
                  default: h(() => [
                    p(s(V, { "terms-text": n(q) }, null, 8, ["terms-text"]), [
                      [d, n(j)]
                    ])
                  ]),
                  _: 1
                })
              ], 8, Ke), [
                [d, !o.value && a.value]
              ])
            ]),
            _: 1
          }, 8, ["name"])
        ], 512), [
          [d, !o.value]
        ])
      ]),
      _: 1
    }));
  }
});
export {
  xo as C,
  Io as N,
  go as _,
  ko as a,
  wo as b,
  yo as c,
  zo as d,
  jo as e,
  bo as f,
  Co as g,
  So as h,
  Do as i
};
//# sourceMappingURL=StickyImage.vue_vue_type_style_index_0_lang.B1aOxgwU.js.map
